// extracted by mini-css-extract-plugin
export default {"tip":"NovaTooltip_tip__V0Jdf","novaTipIn":"NovaTooltip_novaTipIn__huwF1","above":"NovaTooltip_above__5I7VQ","below":"NovaTooltip_below__RKRgf","arrow":"NovaTooltip_arrow__OIAgR"};